
import { PuttSituation } from "@/types/golf";

export const longBunker: PuttSituation = {
  id: 13,
  name: "Bunker long",
  image: "/lovable-uploads/0074efe9-43ee-4a72-8074-8130295c57d2.png",
  description: "Dans le bunker d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point G=25m dans le bunker entre le bord du green et un trou à 10 m maximum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "G", distance: 25, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 38 },
    { points: 1, index: 32 },
    { points: 2, index: 26 },
    { points: 3, index: 21 },
    { points: 4, index: 16 },
    { points: 5, index: 11 },
    { points: 6, index: 8 },
    { points: 7, index: 5 },
    { points: 8, index: 2 },
    { points: 9, index: -1 },
    { points: 10, index: -4 },
    { points: 11, index: -6 },
    { points: 12, index: -8 },
  ],
};
